import { Component } from '@angular/core';
import { LoadingOverlayService } from '../../services/loading-overlay.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent {
  constructor(public loadingService: LoadingOverlayService) {}
}
